import { AtsTicketsOrder } from "../../../../queries/types";
import { OrderDirection } from "../../../../utils/commonQueryTypes";
import { TicketStatus } from "../../../../utils/constants";
import { AtsTicketDetails } from "../../asset/maps/queries/types";
import { AtsAcLdgr } from "../../asset/masters/supplier/queries/types";
import { EmpMaster } from "../../asset/users/queries/types";
import { PageInfo } from "../../customer/settings/predefinedList/queries/types";

export interface TransformTicketDetails {
  ticketDate: string;
  junctionID: number;
  remarks: string;
  reason: string;
  imagesPath: string;
}

export interface AddTransformTicketVar {
  token?: string;
  customerID: number;
  input: TransformTicketDetails;
}

export enum PriorityType {
  CRITICAL = "CRITICAL",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
}

export interface AtsTicketDeviceTypes {
  id:number
  deviceType: String
  numOfUnits: number
  customerID:number
  ticketID:number
}

export interface AtsTickets {
  id: number;
  ticketNo: string;
  ticketDate: string;
  reason: string;
  type: string;
  priority: PriorityType;
  openRemarks: string;
  lastRemarks: string;
  poleNum: number;
  status: TicketStatus;
  ticketDetails: AtsTicketDetails[];
  junction: AtsJunctions;
  vendorDetails: AtsAcLdgr;
  assignedUser: EmpMaster;
  companyID: number;
  junctionID: number;
  deviceTypes: AtsTicketDeviceTypes[];
}

export interface AddTransformTicketResult {
  AddTransformTicket: AtsTickets;
}

export interface AtsJunctions {
  id: number;
  name: string;
  alias: string;
  jType: string;
  arms: number;
  icon: string;
  poles: number;
  code: string;
  address: string;
  place: string;
  state: string;
  pin: string;
  priority: PriorityType;
  country: string;
  isActive: boolean;
  isTrafficSignal: boolean;
  latitude: number;
  longitude: number;
  ticketStatus: TicketStatus;
  junctionStatus: TicketStatus;
  vendorDetails: AtsAcLdgr;
  companyID: number;
}

export interface GetTransformJunctionResult {
  GetTransformJunction: AtsJunctions;
}

export interface GetTransformJunctionVar {
  token?: string;
  customerID: number;
  junctionID: number;
}

export interface GetTransformTicketsVar {
  token?: string;
  after: string | null;
  first: number;
  orderBy: AtsTicketsOrder;
  name: string;
}

export interface AtsTicketsEdge {
  node: AtsTickets;
  cursor: string;
}

export interface AtsTicketsConnection {
  edges: AtsTicketsEdge[];
  pageInfo: PageInfo;
  totalCount: number;
}

export interface GetTransformTicketsResult {
  GetTransformTickets: AtsTicketsConnection;
}

export interface GetTransformTicketDetailsForFollowUpVar {
  token?: string;
  customerID: number;
  ticketID: number;
  junctionID: number;
}

export interface GetTransformTicketDetailsForFollowUpResult {
  GetTransformTicketDetails: AtsTicketDetails[];
}

export enum AtsJunctionsOrderField {
  NAME = "NAME",
  PLACE = "PLACE",
}

export interface AtsJunctionsOrder {
  direction: OrderDirection;
  field: AtsJunctionsOrderField;
}

export interface GetTransformNearByJunctionsVar {
  token?: string;
  longitude: number;
  latitude: number;
  after: string | null;
  first: number;
  orderBy: AtsJunctionsOrder;
  name: string;
}

export interface AtsJunctionsEdge {
  node: AtsJunctions;
  cursor: string;
}

export interface AtsJunctionsConnection {
  edges: AtsJunctionsEdge[];
  pageInfo: PageInfo;
  totalCount: number;
}
export interface GetTransformNearByJunctionsResult {
  GetTransformNearByJunctions: AtsJunctionsConnection;
}

export interface GetTransformEmpDetailsVar {
  token?: string;
}

export interface GetTransformEmpDetailsResult {
  GetTransformEmpDetails: EmpMaster;
}

export interface TransformTicketDetailsInput {
  status: TicketStatus;
  remarks: string;
  imagesPath: string;
}

export interface AddTransformTicketDetailsVar {
  token?: string;
  todaysDate: string;
  customerID: number;
  ticketID: number;
  input: TransformTicketDetailsInput;
}

export interface AddTransformTicketDetailsResult {
  AddTransformTicketDetails: AtsTicketDetails;
}
